var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0686 12.9489C11.8386 11.5589 13.3186 10.7389 14.1786 9.50888C15.0886 8.21888 14.5786 5.80888 11.9986 5.80888C10.3086 5.80888 9.47857 7.08888 9.12857 8.14888L6.53857 7.05888C7.24857 4.92888 9.17857 3.09888 11.9886 3.09888C14.3386 3.09888 15.9486 4.16888 16.7686 5.50888C17.4686 6.65888 17.8786 8.80888 16.7986 10.4089C15.5986 12.1789 14.4486 12.7189 13.8286 13.8589C13.5786 14.3189 13.4786 14.6189 13.4786 16.0989H10.5886C10.5786 15.3189 10.4586 14.0489 11.0686 12.9489ZM13.9986 20.0989C13.9986 21.1989 13.0986 22.0989 11.9986 22.0989C10.8986 22.0989 9.99857 21.1989 9.99857 20.0989C9.99857 18.9989 10.8986 18.0989 11.9986 18.0989C13.0986 18.0989 13.9986 18.9989 13.9986 20.0989Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.4cc7b7e41acc7f22348de160d4e3306a.svg";
export { ForwardRef as ReactComponent };